module.exports = __webpack_public_path__ + "img/DNI-front.c0add1f5.png";